import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import NotFind from "../views/NoteFind.vue";
import store from "../store/index.js";
Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/homehouse",
    name: "/Homehouse",
    component: Home,
    meta: {
      title: "数据管理",
      icon: "el-icon-house",
    },
    redirect: "/welcome",
    children: [
      {
        path: "/welcome",
        name: "Welcome",
        meta: {
          title: "欢迎登录",
        },
        component: () => import("../views/home/Welcome.vue"),
      },
    ],
  },
  {
    path: "/operation",
    component: Home,
    redirect: "/operation/article",
    name: "Operation",
    meta: { title: "运营管理", icon: "el-icon-s-marketing" },
    alwaysShow: true,
    children: [
      {
        id: 9,
        path: "/coupon",
        name: "Coupon",
        component: () => import("@/views/operation/coupon/list"),
        meta: { title: "优惠券" },
      },
      {
        path: "/sendCoupon",
        name: "SendCoupon",
        component: () => import("@/views/operation/coupon/sendCoupon"),
        meta: { title: "赠送优惠券", activeMenu: "/operation/coupon" },
        hidden: true,
      },
      {
        path: "/usedDetail",
        name: "UsedDetail",
        component: () => import("@/views/operation/coupon/usedDetail"),
        meta: { title: "用券明细", activeMenu: "/operation/coupon" },
        hidden: true,
      },
    ],
  },
  {
    path: "/content",
    name: "content",
    component: Home,
    meta: {
      title: "内容管理",
      icon: "el-icon-s-opportunity",
    },
    redirect: "/introduce",
    children: [
      {
        path: "/introduce",
        name: "Introduce",
        meta: {
          title: "协议内容",
        },
        component: () => import("../views/content/Introduce.vue"),
      },
      {
        path: "/introduceEdit",
        name: "IntroduceEdit",
        meta: {
          title: "协议修改",
        },
        component: () => import("../views/content/edit.vue"),
      },
      {
        path: "/repository",
        name: "Repository",
        meta: {
          title: "知识库",
        },
        component: () => import("../views/content/Repository.vue"),
      },
      {
        path: "/addRepository",
        name: "AddRepository",
        meta: {
          title: "添加知识库",
        },
        component: () => import("../views/content/AddRepository.vue"),
      },
      {
        path: "/editRepository",
        name: "EditRepository",
        meta: {
          title: "修改知识库",
        },
        component: () => import("../views/content/EditRepository.vue"),
      },
      {
        path: "/advertise",
        name: "Advertise",
        component: () => import("@/views/content/advertise/index"),
        meta: { title: "广告管理" },
      },
      {
        path: "/regulations",
        name: "Regulations",
        component: () => import("@/views/content/regulations/index"),
        meta: { title: "法律法规" },
      },
      {
        path: "/regulationsClassify",
        name: "RegulationsClassify",
        component: () =>
          import("@/views/content/regulations/regulationsClassify"),
        meta: { title: "法律法规分类" },
      },
      {
        path: "/regulationsAdd",
        name: "RegulationsAdd",
        component: () => import("@/views/content/regulations/regulationsAdd"),
        meta: { title: "添加法律法规" },
      },
      {
        path: "/userGuide",
        name: "UserGuide",
        component: () => import("@/views/content/userGuide/index.vue"),
        meta: { title: "用户指南" },
      },
      {
        path: "/guideAdd",
        name: "GuideAdd",
        component: () => import("@/views/content/userGuide/guideAdd.vue"),
        meta: { title: "添加用户指南" },
      },
      {
        path: "/guideClassify",
        name: "GuideClassify",
        component: () => import("@/views/content/userGuide/guideClassify.vue"),
        meta: { title: "用户指南分类" },
      },
    ],
  },
  {
    path: "/law",
    name: "Law",
    component: Home,
    meta: {
      title: "律师律所",
      icon: "el-icon-chat-round",
    },
    redirect: "/lawFirm",
    children: [
      {
        path: "/lawFirm",
        name: "LawFirm",
        meta: {
          title: "律所管理",
        },
        component: () => import("../views/law/lawFirm/index.vue"),
      },
      {
        path: "/lawFirmAdd",
        name: "LawFirmAdd",
        meta: {
          title: "新增律所",
        },
        component: () => import("../views/law/lawFirm/add.vue"),
      },
      {
        path: "/lawyer",
        name: "Lawyer",
        meta: {
          title: "律师管理",
        },
        component: () => import("../views/law/lawyer/index.vue"),
      },
      {
        path: "/lawyerAdd",
        name: "LawyerAdd",
        meta: {
          title: "新增律师",
        },
        component: () => import("../views/law/lawyer/add.vue"),
      },
    ],
  },
  {
    path: "/sucai",
    name: "Sucai",
    component: Home,
    meta: {
      title: "素材管理",
      icon: "el-icon-chat-round",
    },
    redirect: "/sucaiList",
    children: [
      {
        path: "/summary",
        name: "Summarys",
        meta: {
          title: "素材设置",
        },
        component: () => import("../views/sucai/SumMary.vue"),
      },
      {
        path: "/typemanagent",
        name: "Typemanagent",
        meta: {
          title: "素材分类管理",
        },
        component: () => import("../views/sucai/TypeManagent.vue"),
      },
      {
        path: "/swipermanagent",
        name: "Swipermanagent",
        meta: {
          title: "素材轮播管理",
        },
        component: () => import("../views/sucai/SwiperManagent.vue"),
      },
    ],
  },
  {
    path: "/role",
    name: "Role",
    component: Home,
    meta: {
      title: "权限管理",
      icon: "el-icon-setting",
    },
    redirect: "/adminList",
    children: [
      {
        path: "/adminList",
        name: "AdminList",
        meta: {
          title: "管理员列表",
        },
        component: () => import("../views/roleManagent/adminList.vue"),
      },
      {
        path: "/roleList",
        name: "RoleList",
        meta: {
          title: "角色列表",
        },
        component: () => import("../views/roleManagent/roleList.vue"),
      },
      {
        path: "/authList",
        name: "RuthList",
        meta: {
          title: "权限列表",
        },
        component: () => import("../views/roleManagent/authority.vue"),
      },
      {
        path: "/customerService",
        name: "CustomerService",
        meta: {
          title: "客服管理",
        },
        component: () =>
          import("../views/roleManagent/customerService/index.vue"),
      },
      {
        path: "/receptionRecord",
        name: "ReceptionRecord",
        meta: {
          title: "接待记录",
        },
        component: () =>
          import("../views/roleManagent/receptionRecord/index.vue"),
      },
    ],
  },
  {
    path: "/order",
    name: "Order",
    component: Home,
    meta: {
      title: "订单管理",
    },
    redirect: "/serviceOrder",
    children: [
      {
        path: "/serviceOrder",
        name: "ServiceOrder",
        component: () => import("@/views/order/serviceOrder/index"),
        meta: { title: "服务订单" },
      },
      {
        path: "/serviceOrderDetail",
        name: "ServiceOrderDetail",
        component: () => import("@/views/order/serviceOrder/detail"),
        meta: { title: "服务订单详情" },
        hidden: true,
      },
      {
        path: "/downloadOrder",
        name: "DownloadOrder",
        component: () => import("@/views/order/downloadOrder/index"),
        meta: { title: "合同订单" },
      },
      {
        path: "/phoneOrder",
        name: "PhoneOrder",
        component: () => import("@/views/order/phoneOrder/index"),
        meta: { title: "电话咨询订单" },
      },
      {
        path: "/refundsOrder",
        name: "RefundsOrder",
        component: () => import("@/views/order/refundsOrder/index"),
        meta: { title: "售后订单" },
      },
      {
        path: "/serviceOrderChat",
        name: "ServiceOrderChat",
        component: () => import("@/views/order/chatHistory/index"),
        meta: { title: "聊天记录", activeMenu: "/order/serviceOrder" },
        hidden: true,
      },
    ],
  },
  {
    path: "/workbench",
    name: "workbench",
    component: Home,

    meta: {
      title: "工作台",
    },
    redirect: "/chatrooms",
    children: [
      {
        path: "/chatrooms",
        name: "chatrooms",
        component: () => import("@/views/workbench/chatrooms/index.vue"),
        meta: { title: "客服接待" },
      },
      {
        path: "/askList",
        name: "AskList",
        component: () => import("@/views/workbench/askList/index"),
        meta: { title: "咨询列表" },
      },
      {
        path: "/askHistory",
        name: "AskHistory",
        component: () => import("@/views/workbench/askHistory/index"),
        meta: { title: "历史记录" },
      },
    ],
  },
  {
    path: "/setting",
    name: "setting",
    component: Home,

    meta: {
      title: "系统设置",
    },
    redirect: "/serviceSetting",
    children: [
      {
        path: "/serviceSetting",
        name: "serviceSetting",
        component: () => import("@/views/setting/serviceSetting/index.vue"),
        meta: { title: "服务设置" },
      },
      {
        path: "/liveStrem",
        name: "LiveStrem",
        component: () => import("@/views/setting/liveStrem/index.vue"),
        meta: { title: "直播设置" },
      },
    ],
  },
  {
    path: "/goods",
    name: "Goods",
    component: Home,
    redirect: "/goods/serviceGoods",
    meta: { title: "商品管理", icon: "el-icon-s-goods" },
    children: [
      {
        path: "/serviceGoods",
        name: "ServiceGoods",
        component: () =>
          import("@/views/goods/serviceGoods/goodsList/index.vue"),
        meta: { title: "服务商品" },
      },
      {
        path: "/workTickets",
        name: "WorkTickets",
        component: () =>
          import("@/views/goods/serviceGoods/workTickets/index.vue"),
        meta: { title: "工单模板管理", activeMenu: "/goods/serviceGoods" },
        hidden: true,
      },
      {
        path: "/workTicketsAdd",
        name: "WorkTicketsAdd",
        component: () =>
          import("@/views/goods/serviceGoods/workTickets/workTicketsAdd.vue"),
        meta: { title: "添加工单模板", activeMenu: "/goods/serviceGoods" },
        hidden: true,
      },
      {
        path: "/serviceClassify",
        name: "ServiceClassify",
        component: () =>
          import("@/views/goods/serviceGoods/goodsList/serviceClassify"),
        meta: { title: "服务商品分类", activeMenu: "/goods/serviceGoods" },
        hidden: true,
      },

      {
        path: "/serviceGoodsAdd",
        name: "ServiceGoodsAdd",
        component: () => import("@/views/goods/serviceGoods/goodsList/add"),
        meta: { title: "添加服务商品", activeMenu: "/goods/serviceGoods" },
        hidden: true,
      },
      {
        path: "/contractGoods",
        name: "ContractGoods",
        component: () => import("@/views/goods/contractGoods/list"),
        meta: { title: "合同商品" },
      },
      {
        path: "/contractGoodsAdd",
        name: "ContractGoodsAdd",
        component: () => import("@/views/goods/contractGoods/add"),
        meta: { title: "添加合同商品", activeMenu: "/goods/contractGoods" },
        hidden: true,
      },
      {
        path: "/documentClassify",
        name: "DocumentClassify",
        component: () => import("@/views/goods/contractGoods/documentClassify"),
        meta: { title: "合同分类管理", activeMenu: "/goods/contractGoods" },
        hidden: true,
      },
    ],
  },
  {
    path: "*",
    component: NotFind,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // 获取权限白名单（realPathArr）
  let realPathArr = sessionStorage.getItem("realauthPath");
  const isInAuthWhiteList = !realPathArr
    ? false
    : realPathArr.split(",").includes(to.fullPath); // 是否在权限白名单中
  // 定义「无条件放行的路由路径」（只写基础路径，忽略参数）
  console.log("当前跳转路由是否在白名单中", isInAuthWhiteList);
  const allowPaths = [
    "/introduceEdit",
    "/editRepository",
    "/addRepository",
    "/receptionRecord",
    "/serviceGoodsAdd",
    "/workTicketsAdd",
    "/contractGoodsAdd",
    "/serviceOrderDetail",
    "/serviceOrderChat",
    "/regulationsClassify",
    "/regulationsAdd",
    "/guideClassify",
    "/guideAdd",
    "/lawFirmAdd",
    "/lawyerAdd",
    "/sendCoupon",
    "/usedDetail"
  ];
  // 提取目标路由的「纯路径部分」（去掉所有参数）
  const toBasePath = to.fullPath.split("?")[0];

  // 如果是「无条件放行的路由」→ 直接放行
  if (allowPaths.includes(toBasePath)) {
    console.log("是否放行", allowPaths.includes(toBasePath));
    next();
    return;
  }
  // 如果不在权限白名单中，且不是登录页 → 跳登录
  if (!isInAuthWhiteList && to.fullPath !== "/login") {
    next({ path: "/login" });
    return;
  }

  // ③ 合法路由：继续执行
  sessionStorage.setItem("defaultPatch", to.fullPath);
  next();
});

router.afterEach((to) => {
  // let authList = JSON.parse(sessionStorage.getItem('authList'))
  if (to.fullPath === "/welcome") {
    // 检查浏览器的 sessionStorage 是否有 "hasVisited" 标记
    if (!sessionStorage.getItem("hasVisited")) {
      // 页面第一次加载时执行操作
      console.log("页面刷新时只执行一次操作");

      // 设置标记为 true，防止下次刷新时再次执行
      sessionStorage.setItem("hasVisited", true);
      window.location.reload();
    }
  }
});
export default router;
